<div class="modal-header bg-neutral-50">
  <h4 class="modal-title">Pay invoice</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close(null)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body border-0 bg-neutral-25 modal-view-auction-images">
  <form #thisForm="ngForm">
    <div class="mb-3">
      <span>Paying balance of <strong>${{PayBalance|number:'1.2-2'}}</strong> for invoice number <strong>{{InvoiceNumber}}</strong></span>
    </div>

    <div>
      <div id="card-container"></div>
      <websilk-loading *ngIf="!card" class="text-dark"></websilk-loading>

      <re-captcha #recaptcha (resolved)="CaptchaToken = $event" siteKey="6LecutkZAAAAAITVLZd5-H0wcZ5W6uILIQIoB7zQ"></re-captcha>
    </div>
  </form>
</div>
<div class="modal-footer border-0 bg-neutral-50">
  <button type="button" class="btn btn-primary btn-red pl-2 pr-2 btn-login w-100" *ngIf="!processing && card" [disabled]="!CaptchaToken" (click)="Save(thisForm,$event)">Process payment</button>
  <span class="btn btn-dark" *ngIf="processing"><i class="fa fa-spinner fa-spin"></i> Processing...</span>
</div>
